import React from 'react';
import styled from 'styled-components';
import Button from '@ingka/button';
import InlineMessage from '@ingka/inline-message';
import { Box } from '../styles';
import useTranslation from '../hooks/useTranslation';

export interface RetryMessageProps {
  message: string;
  onRetry: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 272px;
`;

const StyledInlineMessage = styled(InlineMessage)`
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  min-width: 125px;
`;

const RetryMessage: React.FunctionComponent<RetryMessageProps> = ({
  message,
  onRetry,
}): JSX.Element => {
  const { t } = useTranslation();

  const handleOnClick = (e: React.SyntheticEvent<object>): void => {
    e.preventDefault();

    onRetry();
  };

  return (
    <Container>
      <Box data-cy="retry-message">
        <StyledInlineMessage
          subtle
          variant="negative"
          body={message}
          role="alert"
          aria-live="assertive"
        />
        <StyledButton
          onClick={handleOnClick}
          text={t('components.retryMessage.buttonText')}
        />
      </Box>
    </Container>
  );
};

export default RetryMessage;
